import { TransactionsResponse } from '@/interfaces/transactions';
import { Response } from '@/interfaces/api';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';

export function getTransactions(
  abortController?: AbortController,
  params: Record<string, unknown> | URLSearchParams = {},
): Response<TransactionsResponse> {
  return api.client.get(
    `${CONSUMER_API_PATH}/transactions`,
    {
      params,
      signal: abortController?.signal ?? undefined,
    }
  );
}

export function getTransactionTypes() {
  return api.client.get(`${CONSUMER_API_PATH}/transaction-types`);
}
